import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import LeftSidebar from "./LeftSidebar";
import Navbar from "./Navbar";

const MainLayout: React.FC = () => {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false); // Sidebar state
  const [manualControl, setManualControl] = useState(false); // Manual control state
  const year=new Date().getFullYear();

  const toggleSidebar = () => {
    setIsSidebarExpanded((prevState) => !prevState);
    setManualControl((prevState) => !prevState); // Toggle manual control mode
  };

  const handleSidebarHoverStart = () => {
    if (!manualControl) {
      setIsSidebarExpanded(true); // Only expand on hover if not in manual control
    }
  };

  const handleSidebarHoverEnd = () => {
    if (!manualControl) {
      setIsSidebarExpanded(false); // Only collapse on hover if not in manual control
    }
  };

  return (
    <div
      style={{
        display: "grid",
        gridTemplateRows: "auto 1fr auto", // Navbar, Content, Footer
        gridTemplateColumns: isSidebarExpanded ? "200px 1fr" : "100px 1fr", // Sidebar width
        height: "100vh",
      }}
    >
      {/* Navbar */}
      <header
        style={{
          gridColumn: "1 / span 2", // Spans across both sidebar and main content
        }}
      >
        <Navbar
          toggleSidebar={toggleSidebar}
          isSidebarExpanded={isSidebarExpanded}
        />
      </header>

      {/* Sidebar */}
      <aside style={{ gridRow: "2 / 4" }}>
        <LeftSidebar
          isSidebarExpanded={isSidebarExpanded}
          onSidebarHoverStart={handleSidebarHoverStart}
          onSidebarHoverEnd={handleSidebarHoverEnd}
        />
      </aside>

      {/* Main Content */}
      <main
        style={{
          gridColumn: "2 / 3",
          gridRow: "2 / 3",
          padding: "20px",
          backgroundColor: "#f1f4fb",
        }}
      >
        <Outlet />
      </main>

      {/* Footer */}
      <footer
        className="footer-custom"
        style={{
          gridColumn: "2 / 3",
          gridRow: "3 / 4",
          width: isSidebarExpanded ? "calc(100%px)" : "calc(100%)",
        }}
      >
        {/* Logo */}
        <img src="/footerLogo.png" alt="Logo"  height={10} width={250}/>
        <hr style={{ borderColor: "#000", width: "80%" }} />
        {/* Copyright Text */}
        <span>Copyright © {year} - Novus365 - All rights reserved. Version : {process.env.REACT_APP_VERSION}</span>
      </footer>
    </div>
  );
};

export default MainLayout;
